// extracted by mini-css-extract-plugin
export default {"oval":"topBtn_oval__sJ+By","hidden":"topBtn_hidden__GNpBU"};